module.exports = __webpack_public_path__ + "static/media/objects_27.3199cf84.svg";